import * as React from 'react';

// Global counter for open dialogs
let dialogCount = 0;

/**
 * Hook that returns true if this dialog should show its overlay.
 * Only the FIRST dialog to open shows the dark overlay.
 * Subsequent dialogs get a transparent overlay to prevent stacking.
 */
export function useDialogOverlay(): boolean {
  // Capture whether THIS dialog was first at mount time (before incrementing)
  // Using ref so the value persists across re-renders
  const wasFirstRef = React.useRef<boolean | null>(null);

  // On first render (before effect runs), check if we're the first dialog
  if (wasFirstRef.current === null) {
    wasFirstRef.current = dialogCount === 0;
  }

  React.useEffect(() => {
    // Increment count when this dialog mounts
    dialogCount++;

    return () => {
      // Decrement count when this dialog unmounts
      dialogCount = Math.max(0, dialogCount - 1);
    };
  }, []);

  return wasFirstRef.current;
}
